module.exports = __webpack_public_path__ + "82d296bcfed4a623bf3ced58fe59bfcd.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-12.png
// module id = 108
// module chunks = 0